module.exports = __webpack_public_path__ + "img/page.47e42e03.png";